import React from "react";
import gql from "graphql-tag";
import { get } from "lodash";
import { useQuery } from "@apollo/react-hooks";

const categoryMetaTagsQuery = gql`
  query categoryMetaTagsQuery($categorySlug: String!) {
    category(categorySlug: $categorySlug) {
      id
      name
      slug
      metaDescription
    }
  }
`;

function CategoryMetaTagsQuery({
  slug,
  children,
}: {
  slug: string;
  children: any;
}): JSX.Element {
  const { loading, data, error } = useQuery(categoryMetaTagsQuery, {
    variables: { categorySlug: slug },
  });

  const parseData = (data) => ({
    category: get(data, "category", {}),
  });

  if (loading || error) return <></>;

  return children(parseData(data));
}

export default CategoryMetaTagsQuery;
